import 'static/semantic/semantic.js'

import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import Vue from 'vue'
import VueMq from 'vue-mq'
import Meta from 'vue-meta'
import SuiVue from 'semantic-ui-vue'
import VueAnalytics from 'vue-analytics'
import VueScrollTo from 'vue-scrollto'
import { sync } from 'vuex-router-sync'


import config from './config'
import './directives/signup'
import App from './components/App'
import AppFilter from './filters/app'
import NumFilter from './filters/num'
import router from './router'
import store from './store'
import { isDevelopment } from './lib/App'

Raven
  .config(config.sentry.dsn)
  .addPlugin(RavenVue, Vue)
  .install()

Vue.use(SuiVue)

Vue.use(VueScrollTo)

sync(store, router)

Vue.use(VueMq, {
  breakpoints: {
    xxs: 320,
    xs: 425,
    sm: 600,
    md: 960,
    lg: Infinity
  }
})

Vue.use(VueAnalytics, {
  id: config.google.analytics.id,
  checkDuplicatedScript: true,
  // disableScriptLoader: true,
  autoTracking: {
    pageviewOnLoad: true,
    skipSamePath: true
  },
  debug: {
    enabled: isDevelopment()
  },
  router
})

// FILTERS
Vue.use(AppFilter)
Vue.use(NumFilter)

// META
Vue.use(Meta)

const app = new Vue({
  router,
  store,
  ...App
})

export { app, router, store }



// WEBPACK FOOTER //
// ./client/app.js